module.exports = __webpack_public_path__ + "img/denmark-pneumonia-male.16267489.png";